// extracted by mini-css-extract-plugin
module.exports = {"svg":"FallbackImage_svg__U2TiR","image":"FallbackImage_image__4iwmG"};